/**
 * Semantic Tokens - Contextual token mappings from export.json
 */

export const semanticTokens = {
  colors: {
    background: {
      accent: {
        DEFAULT: { value: '{colors.green.500}' },
        hover: { value: '{colors.green.600}' },
        active: { value: '{colors.green.600}' },
      },
      canvas: { value: '{colors.grey.100}' },
      primary: { value: '{colors.grey.white}' },
      secondary: { value: '{colors.purple.100}' },
      tertiary: { value: '{colors.skyBlue.700}' },
      quaternary: { value: '{colors.grey.950}' },
      warning: { value: '{colors.yellow.600}' },
      subtle: {
        red: { value: '{colors.red.100}' },
        green: { value: '{colors.green.100}' },
      },
      error: {
        DEFAULT: { value: '{colors.red.600}' },
        hover: { value: '{colors.red.700}' },
        active: { value: '{colors.red.700}' },
      },
      highlight: {
        green: { value: '{colors.green.300}' },
        red: { value: '{colors.red.300}' },
        yellow: { value: '{colors.yellow.300}' },
      },
    },
    text: {
      primary: { value: '{colors.grey.900}' },
      secondary: { value: '{colors.grey.800}' },
      tertiary: { value: '{colors.grey.700}' },
      quaternary: { value: '{colors.grey.500}' },
      accent: { value: '{colors.green.600}' },
      error: { value: '{colors.red.600}' },
      onAccent: { value: '{colors.grey.white}' },
      info: {
        DEFAULT: { value: '{colors.blue.500}' },
        hover: { value: '{colors.blue.600}' },
        active: { value: '{colors.blue.600}' },
      },
      default: { value: '{colors.grey.200}' },
    },
    icon: {
      primary: { value: '{colors.grey.900}' },
      secondary: { value: '{colors.grey.800}' },
      tertiary: { value: '{colors.grey.700}' },
      quaternary: { value: '{colors.grey.500}' },
      accent: { value: '{colors.green.600}' },
      warning: { value: '{colors.yellow.500}' },
      error: { value: '{colors.red.600}' },
      info: {
        DEFAULT: { value: '{colors.blue.500}' },
        hover: { value: '{colors.blue.600}' },
        active: { value: '{colors.blue.600}' },
      },
      onAccent: { value: '{colors.grey.white}' },
    },
    border: {
      // Used for some components without recipe
      DEFAULT: { value: '{colors.grey.200}' },
      /** Radiomark / checkbox unchecked ring (Chakra `border.emphasized`). */
      emphasized: { value: '{colors.grey.300}' },
      error: { value: '{colors.red.600}' },
      accent: {
        DEFAULT: { value: '{colors.grey.200}' },
        hover: { value: '{colors.grey.300}' },
        active: { value: '{colors.green.500}' },
      },
    },
    divider: {
      default: { value: '{colors.grey.200}' },
    },
    tag: {
      background: {
        green: { value: '{colors.green.200}' },
        blue: { value: '{colors.blue.200}' },
        yellow: { value: '{colors.yellow.200}' },
        purple: { value: '{colors.purple.200}' },
        skyBlue: { value: '{colors.skyBlue.200}' },
      },
      text: {
        green: { value: '{colors.green.700}' },
        blue: { value: '{colors.blue.700}' },
        yellow: { value: '{colors.yellow.700}' },
        purple: { value: '{colors.purple.700}' },
        skyBlue: { value: '{colors.skyBlue.700}' },
      },
    },
    flashcard: {
      background: {
        green: { value: '{colors.green.300}' },
        red: { value: '{colors.red.300}' },
        yellow: { value: '{colors.yellow.300}' },
      },
    },
    specificButtons: {
      google: {
        background: {
          value: '{colors.blue.500}',
        },
      },
      apple: {
        background: {
          value: '{colors.grey.950}',
        },
      },
    },
    menu: {
      text: {
        secondary: {
          value: '{colors.grey.200}',
        },
      },
      icon: {
        secondary: {
          value: '{colors.grey.200}',
        },
      },
    },
    progress: {
      background: {
        value: '{colors.grey.200}',
      },
    },
    switch: {
      background: {
        value: '{colors.grey.300}',
      },
    },

    /**
     * Palette semantics for the `colorPalette` prop (Radio, Checkbox, Switch, etc.).
     * Without these, `colorPalette="green"` has no `colorPalette.solid` / `contrast` / … to resolve.
     */
    green: {
      contrast: { value: '{colors.grey.white}' },
      fg: { value: '{colors.green.700}' },
      subtle: { value: '{colors.green.100}' },
      muted: { value: '{colors.green.200}' },
      emphasized: { value: '{colors.green.300}' },
      solid: { value: '{colors.green.500}' },
      focusRing: { value: '{colors.green.400}' },
      border: { value: '{colors.green.500}' },
    },
    red: {
      contrast: { value: '{colors.grey.white}' },
      fg: { value: '{colors.red.700}' },
      subtle: { value: '{colors.red.100}' },
      muted: { value: '{colors.red.200}' },
      emphasized: { value: '{colors.red.300}' },
      solid: { value: '{colors.red.500}' },
      focusRing: { value: '{colors.red.500}' },
      border: { value: '{colors.red.500}' },
    },
  },
  shadows: {
    md: {
      value: {
        _light: '0px 0px 8px 0px {colors.grey.900/8}',
        _dark: '0px 0px 8px 0px {black/40}',
      },
    },
  },
  opacity: {
    disabled: { value: '{opacity.l}' },
  },
};
